import * as React from "react";
import styled from "styled-components";

export const BoxBody: React.FC = ({children}) => (
    <StyledBody>{children}</StyledBody>
);

const StyledBody = styled('div')`
  padding: 20px 0;
;`